var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingRxChangeIconmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.844 23.25a.469.469 0 01-.469-.469V1.22a.469.469 0 11.938 0V22.78c0 .26-.21.469-.47.469z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.469 8.25a.468.468 0 01-.356-.164L6.488 1.524A.469.469 0 017.2.914l5.625 6.562a.469.469 0 01-.356.774z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.219 8.25a.469.469 0 01-.356-.774L6.488.914a.469.469 0 01.712.61L1.575 8.086a.468.468 0 01-.356.164zM17.156 23.25a.469.469 0 01-.468-.469V1.22a.469.469 0 01.937 0V22.78c0 .26-.21.469-.469.469z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.156 23.25a.468.468 0 01-.356-.774l5.625-6.562a.469.469 0 11.712.61l-5.625 6.562a.467.467 0 01-.356.164z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.156 23.25a.467.467 0 01-.356-.164l-5.625-6.562a.469.469 0 01.712-.61l5.625 6.562a.469.469 0 01-.356.774z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingRxChangeIconmin);
export default __webpack_public_path__ + "static/media/PendingRxChangeIcon.min.4ded26a406fd6c4862470303a63ea303.svg";
export { ForwardRef as ReactComponent };